import { useEffect } from 'react';
import { useTokenBalance } from '../hooks/useTokenBalance';

/**
 * グローバルマイニングエフェクト表示コンポーネント
 * 画面の固定位置にマイニングエフェクトを表示
 */
const GlobalMiningEffect = () => {
  const { miningEffect, dismissMiningEffect } = useTokenBalance();

  useEffect(() => {
    if (miningEffect) {
      // eslint-disable-next-line no-console
      console.log('🎉 GlobalMiningEffect: miningEffect updated:', miningEffect);
    }
  }, [miningEffect]);

  if (!miningEffect) return null;

  return (
    <div
      className="fixed top-20 right-8 pointer-events-auto animate-fade-in"
      style={{ zIndex: 99999 }}
    >
      <div
        className={`font-bold text-xl drop-shadow-2xl ${
          miningEffect.isConsumption ? 'text-red-500' : 'text-green-400'
        }`}
        style={{
          filter: 'drop-shadow(0 0 12px rgba(0,0,0,0.9))',
          textShadow: '0 0 15px rgba(0,0,0,0.9)',
        }}
      >
        <div className="flex items-center space-x-2 bg-black/80 px-4 py-3 rounded-full relative shadow-lg">
          {/* 生態系別アイコン */}
          {miningEffect.icon && (
            <span className="text-2xl animate-pulse">{miningEffect.icon}</span>
          )}
          <span className="font-extrabold">{miningEffect.display} SH</span>
          {/* OKボタン */}
          <button
            onClick={dismissMiningEffect}
            className="ml-3 bg-white/20 hover:bg-white/30 text-white px-3 py-1 rounded-full text-sm font-bold transition-colors"
            title="閉じる"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default GlobalMiningEffect;
